import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { TextDisplay } from "components/dataDisplay/TextDisplay";
import type { Result } from "hooks/utils/material-data";
import type { FC } from "react";
import { Industry } from "./Industry";

export interface CustomerInformationProps {
  material: ColoredMaterial;
  isInternal?: boolean;
  grade: Result | undefined;
}

export const CustomerInformation: FC<CustomerInformationProps> = ({
  material,
  isInternal,
  grade,
}) => {
  const oemNames = material.customer?.oemName;

  return (
    <Stack spacing={3}>
      {isInternal && (
        <>
          <Box>
            <Grid container spacing={1}>
              <Grid size={5}>
                <Typography variant="label">Customer</Typography>
              </Grid>
              <Grid size={7}>
                <TextDisplay value={material.customer?.customerName} />
              </Grid>
              <Grid size={5}>
                <Typography variant="label">OEM</Typography>
              </Grid>
              <Grid size={7}>
                {oemNames?.length ? (
                  oemNames.map((oemName) => (
                    <TextDisplay key={oemName} value={oemName} />
                  ))
                ) : (
                  <TextDisplay value={undefined} />
                )}
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Grid container spacing={1}>
              <Grid size={5}>
                <Typography variant="label">OEM color code</Typography>
              </Grid>
              <Grid size={7}>
                <TextDisplay value={material.customer?.oemColorCode} />
              </Grid>
              <Grid size={5}>
                <Typography variant="label">OEM color name</Typography>
              </Grid>
              <Grid size={7}>
                <TextDisplay value={material.customer?.oemColorName} />
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* <Box>
      <Grid container spacing={1}>
        <Grid size={5}><Typography variant="label">OEM industry</Typography></Grid>
        <Grid size={7}><TextDisplay value={material.customer?.oemIndustry}/></Grid>
        <Grid size={5}><Typography variant="label">OEM application</Typography></Grid>
        <Grid size={7}><TextDisplay value={material.customer?.oemApplication}/></Grid>
      </Grid>
    </Box> */}

      <Industry grade={grade} />
    </Stack>
  );
};
